import axios from 'axios'
import { config } from '../config'
import { clearSession, getToken } from './session'

const baseURL = config.apiUrl

export const api = axios.create({
	baseURL: `${baseURL}/v1`,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
	timeout: 15000,
})

// Request interceptor to add auth token
api.interceptors.request.use(config => {
	const token = getToken()
	if (token) {
		config.headers.set('Authorization', `Bearer ${token}`)
	}
	return config
})

api.interceptors.response.use(
	response => response,
	error => {
		// Handle 401 errors by clearing auth and redirecting to login
		if (error.response?.status === 401) {
			clearSession()
			window.location.href = '/'
		}
		const errorToReject = error instanceof Error ? error : new Error(String(error))
		return Promise.reject(errorToReject)
	},
)

export default api
